import { Injectable } from '@angular/core';

import { FetchStrategy } from '../instrumentation/instrumented-http.service';
import { FileType } from '../models/file-item.model';
import { SwayAnalytics } from '../models/sway.model';
import { Analytics } from '../mru/analytics.model';
import { MruConfigService } from '../mru/mru-config.service';
import { MruFileItem } from '../mru/mru-file-item.model';
import { SwayService } from '../services/sway.service';

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {

    constructor(
        private readonly mruConfigService: MruConfigService,
        private readonly swayService: SwayService
    ) {
    }

    public getAnalytics(item: MruFileItem, strategy: FetchStrategy): Promise<Analytics> {
        if (strategy === FetchStrategy.CacheOnly && !this.mruConfigService.config.analyticsCachingEnabled) {
            return Promise.resolve(undefined);
        }

        if (item.fileType === FileType.Sway) {
            return this.swayService.getAnalytics(item.url, strategy).then(response => AnalyticsService.convertFromSwayAnalytics(response));
        } else {
            return Promise.resolve(undefined);
        }
    }

    public prefetchAnalytics(items: Array<MruFileItem>, fromCache: boolean): void {
        if (fromCache && !this.mruConfigService.config.analyticsCachingEnabled) {
            return;
        }

        const swayUrls = items.filter(item => item.fileType === FileType.Sway).map(item => item.url);
        const strategy = fromCache ? FetchStrategy.CacheOnly : FetchStrategy.NetworkFirst;
        this.swayService.prefetchAnalytics(swayUrls, strategy);
    }

    private static convertFromSwayAnalytics(swayAnalytics: SwayAnalytics): Analytics {
        if (!swayAnalytics) {
            return undefined;
        }

        return {
            viewCount: swayAnalytics.viewCount,
            averageTimeSpentMs: swayAnalytics.averageTimeSpent,
            averageCompletionRatio: swayAnalytics.AverageScrollDistance,
            glancedReads: swayAnalytics.glancedReads,
            quickReads: swayAnalytics.quickReads,
            deepReads: swayAnalytics.deepReads
        };
    }
}
